import React from 'react';
import { Input } from './ui/input';

const UpperCaseInput = React.forwardRef(({ onChange, ...props }, ref) => {
  const handleChange = (e) => {
    const upperValue = e.target.value.toUpperCase();
    e.target.value = upperValue;
    if (onChange) {
      onChange(e);
    }
  };

  return <Input ref={ref} {...props} onChange={handleChange} />;
});

UpperCaseInput.displayName = 'UpperCaseInput';

export default UpperCaseInput;
